export type MateriaStatus = 'rascunho' | 'em_aprovacao' | 'ajustado' | 'publicado'

export const STATUS_OPTIONS: { value: MateriaStatus; label: string }[] = [
  { value: 'rascunho', label: 'Rascunho' },
  { value: 'em_aprovacao', label: 'Em aprovação' },
  { value: 'ajustado', label: 'Ajustado' },
  { value: 'publicado', label: 'Publicado' },
]

export function statusLabel(status: string): string {
  return STATUS_OPTIONS.find((s) => s.value === status)?.label ?? status
}
